import styles from './style.postcss';

import React, { PureComponent } from 'react';
import TaskProgressCard from 'components/TaskProgressCard';
import { bindActionCreators } from 'redux';
import {
  actions as taskActions,
  accessors as taskAccessors,
  taskStatisticActions
} from 'data/Tasks';
import {
  ApiCall,
  ApiResponseHelper,
  Form,
  Grid,
  connect,
  testClass,
  ConfirmDialog,
  PrivilegeChecker,
} from 'omni-common-ui';
import Privileges from 'domain/Privileges';
import { TableView, TableViewTr, StatusTd, DetailLinkTd,
  TextTd, ButtonTd } from 'components/TableView';
import PropTypes from 'prop-types';
import { TaskFilter } from '../MyTasks';

const FILTER_TYPE_TASK_OWNER = 'taskOwner';
const FILTER_TYPE_TASK_CENTRE = 'taskCentre';
const FILTER_TYPE_TASK_SUBJECT = 'taskSubject';

const convertNamesToLabelsAndIdsToValues = (list) =>
  list.map((item) => ({ label: item.name, value: item.id }));

const convertDescriptionsToLabelsAndCodesToValues = (list) =>
  list.map((item) => ({ label: taskAccessors.getTaskSubject(item.description), value: item.code }));

export class TeacherTasks extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      filterParams: {
        pageSize: 10,
        pageNumber: 1,
        sortBy: 'generatedTime',
        sortType: 'Descending',
        [FILTER_TYPE_TASK_OWNER]: 0,
        [FILTER_TYPE_TASK_CENTRE]: 0,
        [FILTER_TYPE_TASK_SUBJECT]: 0,
      },
      taskFilter: false,
      shouldPopupDialog: false,
    };

    this._renderTableRow = this._renderTableRow.bind(this);
    this._handleOnFilterChange = this._handleOnFilterChange.bind(this);
  }

  componentDidMount() {
    this._fetchTaskStatistics('teacher-tasks');
    this.props.fetchTaskCentresIfNeeded();
    this.props.fetchTaskOwnersIfNeeded();
    this.props.fetchTaskTypesIfNeeded();
    if (this.props.taskCentres.size > 0) {
      this._handleTableFilterChanged(FILTER_TYPE_TASK_CENTRE, this.props.taskCentres.get(0).id);
    }
  }

  componentWillReceiveProps(props) {
    if (this.props.taskCentres.size === 0 && props.taskCentres.size > 0) {
      const centreId = props.taskCentres.get(0).id;
      this._handleTableFilterChanged(FILTER_TYPE_TASK_CENTRE, centreId);
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.filterParams === this.state.filterParams) {
      return;
    }

    this._fetchDosTasks(nextState.filterParams);
  }

  _onCancelTaskButtonClick(taskId) {
    this._toggleConfirmDialog(true, taskId);
  }

  _toggleConfirmDialog(isDialogShow, taskId) {
    this.setState({ shouldPopupDialog: isDialogShow, currentTaskId: `${taskId}` });
  }

  _onDiscardClicked() {
    this._toggleConfirmDialog(false);
  }

  _onSaveButtonClicked() {
    const currentTaskId = this.state.currentTaskId;
    if (currentTaskId) {
      this.props.cancelTask(currentTaskId)
        .then(() => this._toggleConfirmDialog(false))
        .then(() => this._fetchDosTasks(this.state.filterParams));
    }
  }

  _renderConfirmDialog() {
    return <ConfirmDialog isOpen={this.state.shouldPopupDialog}
        primaryButtonContent="Yes"
        secondaryButtonContent="No"
        onPrimaryClick={() => this._onSaveButtonClicked()}
        onSecondaryClick={() => this._onDiscardClicked()}
        onRequestClose={() => this._onDiscardClicked()}>
      <span>This task will be deleted from task owner's task list.</span><br />
      <span>Are you sure you want to cancel this task.</span>
    </ConfirmDialog>;
  }

  _renderStatisticCard() {
    const taskCounts = this.props.taskStatisticResult.taskStatistics || [];
    const sinceTime = this.props.taskStatisticResult.statisticFromDateTime || '';
    return <TaskProgressCard cardTitle="Staff Tasks Completion"
        className={testClass('staff-tasks-completion')}
        tasksCounts={taskCounts}
        sinceTime={sinceTime} />;
  }

  _handleOnFilterChange(filterParams) {
    this.setState({ filterParams });
  }

  _handleTableFilterChanged(type, value) {
    const filterParams = {
      pageSize: 10,
      pageNumber: 1,
      sortBy: 'generatedTime',
      sortType: 'Descending',
      [FILTER_TYPE_TASK_OWNER]: this.state.filterParams.taskOwner || 0,
      [FILTER_TYPE_TASK_CENTRE]: this.state.filterParams.taskCentre || 0,
      [FILTER_TYPE_TASK_SUBJECT]: this.state.filterParams.taskSubject || 0,
    };
    Object.assign(filterParams, { [type]: value || 0 });

    this._handleOnFilterChange(filterParams);
  }

  _fetchTaskStatistics(taskFilter = this.state.taskFilter) {
    this.props.fetchTaskStatistics('teacher-tasks', taskFilter);
  }

  _fetchDosTasks(filterParams = this.state.filterParams, taskFilter = this.state.taskFilter) {
    const filter = { ...filterParams, taskFilter };
    this.props.fetchDosTasks(filter);
  }

  _handleOnTaskFilterChange(taskFilter) {
    this.setState({ taskFilter });
    this._fetchDosTasks(this.state.filterParams, taskFilter);
    this._fetchTaskStatistics(taskFilter);
  }

  _renderTableRow(row) {
    const { hasCancelTaskPrivilege } = this.props;
    return <TableViewTr>
      <TextTd text={taskAccessors.getTaskSubject(row.subject)} />
      <TextTd text={row.owner} />
      <StatusTd text={row.statusName} />
      <TextTd text={row.itemsAffected} />
      <TextTd text={row.details} />
      <TextTd text={row.dueDate} />
      { hasCancelTaskPrivilege && <ButtonTd text="Cancel"
          onButtonClick={() => this._onCancelTaskButtonClick(row.id)} /> }
      <DetailLinkTd url={row.redirectUrl} />
    </TableViewTr>;
  }

  _renderTaskOwnerFilter() {
    const { taskOwnersResult } = this.props;
    if (! taskOwnersResult.data) return;
    return <Form.Select clearable
        searchable
        name="owner"
        label="Select Owner"
        options={convertNamesToLabelsAndIdsToValues(taskOwnersResult.data)}
        value={this.state.filterParams[FILTER_TYPE_TASK_OWNER]}
        setValue={(value) => {
          this._handleTableFilterChanged(FILTER_TYPE_TASK_OWNER, value);
        }}
        fieldOptions={{
          className: styles.TeacherTasks_filters_field,
          labelTextClassName: styles.TeacherTasks_filters_field_label,
          neighborStackMode: 'horizontal',
          innerStackMode: 'vertical',
        }} />;
  }

  _renderTaskCentreFilter() {
    const { taskCentres } = this.props;
    return <Form.Select clearable={false}
        searchable
        name="centre"
        label="Select Centre"
        options={convertNamesToLabelsAndIdsToValues(taskCentres.toJS())}
        value={this.state.filterParams[FILTER_TYPE_TASK_CENTRE]}
        setValue={(value) => {
          this._handleTableFilterChanged(FILTER_TYPE_TASK_CENTRE, value);
        }}
        fieldOptions={{
          className: styles.TeacherTasks_filters_field,
          labelTextClassName: styles.TeacherTasks_filters_field_label,
          neighborStackMode: 'horizontal',
          innerStackMode: 'vertical',
        }} />;
  }

  _renderTaskTypesFilter() {
    const { taskTypes } = this.props;
    const options = taskTypes.filter((type) => type.code !== 'MA');
    return <Form.Select clearable
        searchable
        name="subject"
        label="Select Subject"
        options={convertDescriptionsToLabelsAndCodesToValues(options.toJS())}
        value={this.state.filterParams[FILTER_TYPE_TASK_SUBJECT]}
        setValue={(value) => {
          this._handleTableFilterChanged(FILTER_TYPE_TASK_SUBJECT, value);
        }}
        fieldOptions={{
          className: styles.TeacherTasks_filters_field,
          labelTextClassName: styles.TeacherTasks_filters_field_label,
          neighborStackMode: 'horizontal',
          innerStackMode: 'vertical',
        }} />;
  }

  _renderTaskFilters() {
    return <Form className={styles.TeacherTasks_filters}>
      {this._renderTaskCentreFilter()}
      {this._renderTaskOwnerFilter()}
      {this._renderTaskTypesFilter()}
    </Form>;
  }

  _renderTaskTable() {
    const { dosTaskFilterResult, hasCancelTaskPrivilege } = this.props;
    if (! ApiResponseHelper.hasSucceeded(dosTaskFilterResult)) {
      return null;
    }

    const data = dosTaskFilterResult.data;
    const headers = [{ key: 'subject', text: 'Subject', sortable: true },
      { key: 'firstName', text: 'Owner', sortable: true },
      { key: 'statusName', text: 'Status', sortable: true },
      { key: 'itemsAffected', text: 'Items Affected', sortable: true },
      { key: 'description', text: 'Details', sortable: true },
      { key: 'dueDateTimeUtc', text: 'Due Date', sortable: true },
      { key: 'link', text: '', sortable: false }];
    hasCancelTaskPrivilege && headers.splice(- 1, 0, { key: 'CancelButton', text: '', sortable: false });
    return <Grid.Item>
      <TableView tableTitle="Staff Tasks"
          className={testClass('staff-tasks')}
          noResultsString="No results yet."
          totalRecords={data.totalRecords}
          source={data.tasks}
          headers={headers}
          pageable
          query={this.state.filterParams}
          renderTableRow={this._renderTableRow}
          onFilterChange={this._handleOnFilterChange}
          customerPageControlRightPart={this._renderTaskFilters()} />
    </Grid.Item>;
  }

  render() {
    return <Grid outerMargin>
      <Grid.Group>
        <Grid.Item>
          <TaskFilter value={this.state.taskFilter}
              handleFilterChange={(val) => this._handleOnTaskFilterChange(val)} />
        </Grid.Item>
        <Grid.Item>{ this._renderStatisticCard() }</Grid.Item>
        {this._renderTaskTable()}
      </Grid.Group>
      {this._renderConfirmDialog()}
    </Grid>;
  }
}

TeacherTasks.propTypes = {
  dosTaskFilterResult: PropTypes.object,
  taskOwnersResult: PropTypes.object,
  fetchDosTasks: PropTypes.func.isRequired,
  fetchTaskOwnersIfNeeded: PropTypes.func.isRequired,
  taskStatisticResult: PropTypes.object,
  fetchTaskStatistics: PropTypes.func.isRequired,
  fetchTaskCentresIfNeeded: PropTypes.func.isRequired,
  fetchTaskTypesIfNeeded: PropTypes.func.isRequired,
  taskCentres: PropTypes.object.isRequired,
  taskTypes: PropTypes.object.isRequired,
  isLoadingTaskCentres: PropTypes.bool.isRequired,
  hasCancelTaskPrivilege: PropTypes.bool.isRequired,
  cancelTask: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const dosTaskFilterResult = state.get('rootReducer').get('dosTaskFilterResult');
  const taskOwnersResult = state.get('rootReducer').get('taskOwnersResult');
  const taskCentres = state.get('rootReducer').get('taskCentres');
  const taskTypes = state.get('rootReducer').get('taskTypes');
  const taskStatisticResult = state.get('rootReducer').get('taskStatisticResult');
  const isLoadingTaskCentres = _isLoadingTaskCentres(state);
  return {
    dosTaskFilterResult,
    taskOwnersResult,
    taskCentres,
    taskTypes,
    taskStatisticResult,
    isLoadingTaskCentres,
    hasCancelTaskPrivilege: PrivilegeChecker
      .hasPrivilege(state, Privileges.GroupTask.CancelGroupTask),
  };
}

function _isLoadingTaskCentres(state) {
  const callState = ApiCall.find(state, { method: 'GET', url: taskActions.taskOwnersUrl });
  return ApiCall.State.isValue(callState) && ApiCall.State.isLoading(callState);
}

function mapDispatchToProps(dispatch) {
  return Object.assign({},
    bindActionCreators(taskActions, dispatch),
    bindActionCreators(taskStatisticActions, dispatch),
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TeacherTasks);



// WEBPACK FOOTER //
// ./containers/UserDashboard/TeacherTasks/component.jsx